export const isNumeric = num => {
  return !isNaN(parseInt(num));
};
